import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Download, ChevronDown, ChevronRight, Sparkles } from "lucide-react";

export default function Reports() {
  const [weekly, setWeekly] = useState([]);
  const [expanded, setExpanded] = useState(0);

  useEffect(() => {
    api.get("/reports").then(({ data }) => setWeekly(data.weekly || []));
  }, []);

  return (
    <div className="space-y-6" data-testid="reports-page">
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-[#2C6BAC] font-semibold">Reports</p>
        <h1 className="font-display text-3xl text-[#1A1A2E] mt-1">Your focus, week over week.</h1>
        <p className="text-sm text-[#555568] mt-2">Weekly cards with focus trends, FACE breakdowns, and Compass commentary.</p>
      </div>

      <div className="rounded-xl bg-gradient-to-br from-[#1A3A5C] to-[#2C6BAC] text-white p-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4" data-testid="ai-report-card">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <Sparkles size={14} />
            <p className="text-xs uppercase tracking-[0.2em] font-semibold">AI Insights Report · Quarterly</p>
          </div>
          <h2 className="font-display text-2xl tracking-tight">Q1 2026 - your focus profile.</h2>
          <p className="text-sm text-[#E8ECF2]/85 mt-1">Available now to all Sync, Momentum and Command tiers.</p>
        </div>
        <Button className="bg-white text-[#1A3A5C] hover:bg-[#E8ECF2]">View report</Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {weekly.map((w, i) => (
          <div key={w.id} className="rounded-xl border border-[#E8ECF2] bg-white" data-testid={`report-${i}`}>
            <button
              onClick={() => setExpanded(expanded === i ? -1 : i)}
              className="w-full p-5 text-left flex items-center justify-between"
            >
              <div>
                <p className="font-display font-bold text-[#1A1A2E]">{w.label}</p>
                <p className="text-xs text-[#555568] font-mono mt-1">
                  Focus {w.avg_focus_score} · {w.face_events} events · avg refocus {w.avg_refocus_seconds}s
                </p>
              </div>
              {expanded === i ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
            </button>
            {expanded === i && (
              <div className="border-t border-[#E8ECF2] p-5 space-y-4 text-sm">
                <div className="rounded-md bg-[#F8F9FC] border border-[#E8ECF2] p-4">
                  <p className="text-xs uppercase tracking-[0.18em] text-[#2C6BAC] font-semibold mb-1">AI-Generated Insight</p>
                  <p className="text-[#1A1A2E] leading-relaxed">{w.ai_summary}</p>
                </div>
                <div className="flex gap-2">
                  <Button variant="outline" size="sm"><Download size={14} className="mr-2" />PDF</Button>
                  <Button variant="outline" size="sm"><Download size={14} className="mr-2" />CSV</Button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
